import api from "./apiLogisticsTool.js";

export default {
  //metodo che mi serve quando devo visualizzare la mail (proxy backend verso UsersManagement)
  vUsersReadByEmail(mail) {
    return api.post("UM/vUsersReadByEmail", '"' + mail + '"', {
      headers: {
        "Content-Type": "application/json"
      }
    });
  }
};
